<template>
  <div class="container">
    <div class="bindWrap">
      <p class="pb22 fs16 fwb">{{ $t("account.bind.title") }}</p>
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="0px" class="msContent">
        <el-form-item prop="phone" class="wdb100 mb28">
          <prefix-phone v-model="dataForm.phone"></prefix-phone>
        </el-form-item>
        <div class="wdb100 login-btn">
          <el-button type="primary" @click="submitForm">{{ $t("account.bind.bindBut") }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapGetters } from "vuex";
export default {
  name: "Bind",
  mixins: [validatorMixin],
  data() {
    return {
      dataForm: {
        phone: "",
      },
      dataRule: {
        phone: [
          {
            required: true,
            validator: this.validatePhone,
            trigger: "submit",
          },
        ],
      },
      clickSwitch: true, // 防止恶意提交
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 确认修改按钮
    submitForm() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          if (this.clickSwitch) {
            this.register();
          }
        } else {
          return false;
        }
      });
    },
    // http - 找回密码
    register() {
      // 关闭提交按钮
      this.clickSwitch = false;
      postRequest("/bindPhone", {
        ...this.dataForm,
      })
        .then(res => {
          this.$message({
            message: this.$t("account.bind.succeed"),
            type: "success",
            duration: 1000,
            onClose: () => {
              this.$router.push("/account");
            },
          });
        })
        .catch(err => {
          this.clickSwitch = true;
        });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.bindWrap {
  width: 450px;
}

.msContent {
  width: 100%;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 42px;
  font-size: 16px;
  font-weight: 600;
}

.loginTips {
  font-size: 14px;
  line-height: 30px;
}

.loginTips a {
  color: #409eff;
}

.footBox {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  text-align: center;
}
</style>
